/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_CanceledInputs */

const en_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`canceled`)
};

const id_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dibatalkan`)
};

const ms_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dibatalkan`)
};

const ca_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cancel·lat`)
};

const cs_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zrušeno`)
};

const da_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`opsagt`)
};

const de_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekündigt`)
};

const et_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tühistatud`)
};

const es_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cancelado`)
};

const fr_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`annulé`)
};

const hr_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`otkazano`)
};

const it_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellato`)
};

const lv_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atcelts`)
};

const lt_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atšaukta`)
};

const hu_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`törölve`)
};

const nl_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`opgezegd`)
};

const nb_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`avsluttet`)
};

const pl_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anulowano`)
};

const pt_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cancelado`)
};

const ro_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anulat`)
};

const sk_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zrušené`)
};

const sl_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`preklicano`)
};

const fi_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`peruttu`)
};

const sv_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`avbruten`)
};

const vi_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đã hủy`)
};

const tr_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iptal edildi`)
};

const el_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ακυρώθηκε`)
};

const bg_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`отменени`)
};

const ru_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`отменено`)
};

const sr_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`отказано`)
};

const uk_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`скасовано`)
};

const ka_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გაუქმებული`)
};

const hi_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैंसल्ड `)
};

const th_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิก`)
};

const ko_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`취소됨`)
};

const zh_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已取消`)
};

const zh_tw_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已取消`)
};

const ja_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセルされました`)
};

/**
* | output |
* | --- |
* | "canceled" |
*
* @param {Status_CanceledInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const status_canceled = /** @type {((inputs?: Status_CanceledInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_CanceledInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_status_canceled(inputs)
	if (locale === "ms") return ms_status_canceled(inputs)
	if (locale === "ca") return ca_status_canceled(inputs)
	if (locale === "cs") return cs_status_canceled(inputs)
	if (locale === "da") return da_status_canceled(inputs)
	if (locale === "de") return de_status_canceled(inputs)
	if (locale === "et") return et_status_canceled(inputs)
	if (locale === "es") return es_status_canceled(inputs)
	if (locale === "fr") return fr_status_canceled(inputs)
	if (locale === "hr") return hr_status_canceled(inputs)
	if (locale === "it") return it_status_canceled(inputs)
	if (locale === "lv") return lv_status_canceled(inputs)
	if (locale === "lt") return lt_status_canceled(inputs)
	if (locale === "hu") return hu_status_canceled(inputs)
	if (locale === "nl") return nl_status_canceled(inputs)
	if (locale === "nb") return nb_status_canceled(inputs)
	if (locale === "pl") return pl_status_canceled(inputs)
	if (locale === "pt") return pt_status_canceled(inputs)
	if (locale === "ro") return ro_status_canceled(inputs)
	if (locale === "sk") return sk_status_canceled(inputs)
	if (locale === "sl") return sl_status_canceled(inputs)
	if (locale === "fi") return fi_status_canceled(inputs)
	if (locale === "sv") return sv_status_canceled(inputs)
	if (locale === "vi") return vi_status_canceled(inputs)
	if (locale === "tr") return tr_status_canceled(inputs)
	if (locale === "el") return el_status_canceled(inputs)
	if (locale === "bg") return bg_status_canceled(inputs)
	if (locale === "ru") return ru_status_canceled(inputs)
	if (locale === "sr") return sr_status_canceled(inputs)
	if (locale === "uk") return uk_status_canceled(inputs)
	if (locale === "ka") return ka_status_canceled(inputs)
	if (locale === "hi") return hi_status_canceled(inputs)
	if (locale === "th") return th_status_canceled(inputs)
	if (locale === "ko") return ko_status_canceled(inputs)
	if (locale === "zh") return zh_status_canceled(inputs)
	if (locale === "zh-tw") return zh_tw_status_canceled(inputs)
	if (locale === "ja") return ja_status_canceled(inputs)
	return en_status_canceled(inputs)
});